import fileDownload from 'js-file-download';

export const getPdfFromBase64 = (baseStr: string, mime = 'application/pdf') => {
  const base64Matcher = new RegExp(
    '^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})([=]{1,2})?$'
  );
  let byteCharacters = baseStr;
  if (base64Matcher.test(baseStr)) byteCharacters = atob(baseStr); // проверка на наличие кодировки

  const byteArrays = [];
  const sliceSize = 512; // slice for better performance

  for (let i = 0; i < byteCharacters.length; i += sliceSize) {
    const slice = byteCharacters.slice(i, i + sliceSize);
    const byteNumbers = new Array(slice.length);

    for (let j = 0; j < slice.length; j += 1) {
      byteNumbers[j] = slice.charCodeAt(j);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: mime });
  return blob;
};

export const downloadFile = (
  data: Blob | ArrayBuffer,
  fileName: string,
  mime: string
) => {
  fileDownload(data, fileName, mime);
};

export const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  const chunkSize = 8192;
  for (let i = 0; i < len; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }
  return btoa(binary);
};
